module.exports = __webpack_public_path__ + "static/media/back-arrow.81c32072.png";